<template>
  <div>
    <!-- <div class="filter_div">
      <el-input placeholder=""
                v-model="keyword"
                class="device_input">
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="handleSearch"></el-button>
      </el-input>
    </div> -->
    <div
      class="filter_actions ac"
      style="margin: 0 0 15px"
      v-if="!addCollectionVisible"
    >
      <div
        @click="addCollection"
        class="add_c"
        style="min-width: 120px"
        v-if="!addCollectionVisible && collectionCameraData.length === 0"
      >
        <el-button
          type="primary"
          style="padding: 3px 10px"
          icon="iconfont icon-xinzeng"
          >{{ $t("video.label.newAdd") }}</el-button
        >
      </div>
    </div>
    <div
      v-loading="dataLoading"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      style="height: calc(100vh - 350px); display: flex; flex-direction: column"
    >
      <div class="add_collection_d" v-if="addCollectionVisible">
        <div class="checked_box"></div>
        <i class="el-icon-caret-right"></i>
        <!-- <i class="el-icon-folder file_class"></i> -->
        <i class="el-icon-folder file_class"></i>
        <ioc-input-edit
          style="height: 32px"
          v-model="collectionName"
          @save="handleSave"
          @cancel="handleCancel"
        >
        </ioc-input-edit>
      </div>
      <el-scrollbar
        style="height: 100%"
        v-if="mData.length > 0"
        tag="ul"
        class="collection_ul"
        ref="collectionScrollBar"
      >
        <li v-for="(item, key) in mData" :key="key">
          <div
            :class="[
              'collection_li_container',
              hasActiveClass(item.id),
              hasEditClass(item.id),
            ]"
            @click="handleActiveExpand(item.id)"
          >
            <div
              :class="[
                'checked_box',
                hasCollectionChecked(item.id),
                hasSemiClass(item.id),
              ]"
              @click.stop="handleChecked(item)"
            >
              <i class="el-icon-check"></i>
            </div>
            <div class="collection_content">
              <template v-if="activeExpand === item.id && expand">
                <i class="el-icon-caret-bottom"></i>
              </template>
              <template v-else>
                <i class="el-icon-caret-right"></i>
              </template>
              <i class="el-icon-folder file_class"></i>
              <template v-if="isEdit && activeCamera === item.id">
                <ioc-input-edit
                  style="height: 36px; flex: 1"
                  v-model="editCollectionName"
                  @save="handleSaveEdit(item)"
                  @cancel="handleEditCancel"
                >
                </ioc-input-edit>
              </template>
              <template v-else>
                <div class="label" :title="item.name">
                  {{ item.name }}
                </div>
              </template>
              <div class="collection_options">
                <!-- <el-tooltip :content="$t('ocx.player.play')" placement="top" v-if="showPlayVideo" >
                  <i @click.stop="handlePlayFa(item.id,item.favcameras)"
                    class="iconfont icon-shoucangjia-bofang"></i>
                </el-tooltip>
                <el-tooltip :content="$t('ocx.player.play')" placement="top" v-else style="visibility: hidden">
                  <i class="iconfont icon-shoucangjia-bofang"></i>
                </el-tooltip> -->
                <el-tooltip :content="$t('video.button.edit')" placement="top">
                  <i
                    @click.stop="handleEdit(item)"
                    class="iconfont icon-xiugai"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  :content="$t('video.button.delete')"
                  placement="top"
                >
                  <i
                    @click.stop="handleDel(item)"
                    class="iconfont icon-shanchu"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <ul
            v-if="item.children && item.children.length > 0"
            :class="['collection_ul', 'sub', hasExpandClass(item.id)]"
          >
            <li
              v-for="(camera, index) in item.children"
              :key="index"
              @dblclick="hanleDbclickPlay(camera)"
            >
              <div
                :class="[
                  'collection_li_container_sub',
                  hasActiveClass(camera.id + '_' + camera.thirdCameraId),
                  hasEditClass(camera.id + '_' + camera.thirdCameraId),
                ]"
                @click="handleActiveCamera(camera)"
              >
                <div
                  :class="['checked_box', hasCameraChecked(camera)]"
                  @click.stop="handleCameraChecked(camera, item.children)"
                >
                  <i class="el-icon-check"></i>
                </div>
                <div class="collection_content">
                  <i
                    :class="[
                      'iconfont',
                      hasCameraTypeClass(camera.cameraType),
                      'device_icon',
                    ]"
                  ></i>
                  <template
                    v-if="
                      isEdit &&
                      activeCamera === camera.id + '_' + camera.thirdCameraId
                    "
                  >
                    <ioc-input-edit
                      style="height: 36px; flex: 1"
                      v-model="editCollectionName"
                      @save="handleCameraSaveEdit(camera)"
                      @cancel="handleEditCancel"
                    >
                    </ioc-input-edit>
                  </template>
                  <template>
                    <div
                      class="label"
                      @dblclick="deviceChoose(camera)"
                      :title="item.name"
                    >
                      {{ camera.name }}
                    </div>
                  </template>

                  <div class="icon_type">
                    <i
                      :class="[
                        'iconfont',
                        hasAttributeTypeClass(camera.cameraType),
                      ]"
                    ></i>
                  </div>
                  <div class="collection_options">
                    <i
                      @click.stop="handleCameraEdit(camera)"
                      class="iconfont icon-cameratranslate"
                    ></i>
                    <i
                      @click.stop="handleDelCamera(camera)"
                      class="iconfont icon-shanchu"
                    ></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </el-scrollbar>
      <div class="position-no-result" v-else>
        <p>
          <i class="iconfont icon-icon_Warning1"></i
          ><span>{{ $t("video.label.list") }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import IocInputEdit from "@src/components/common/ioc-component/ioc-input-edit";
import { api } from "../../api";
export default {
  components: {
    IocInputEdit,
  },
  props: {
    // addCollectionVisible: {
    //   type: Boolean,
    //   default: false
    // },
    showPlayVideo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      keyword: "",
      collectionCameraData: [],
      collectionName: "",
      mData: [],
      expand: false,
      activeExpand: "",
      editCollectionName: "",
      isEdit: false,
      checkedList: [],
      collectionChecked: [],
      activeCamera: "",
      semiChecked: [],
      attributeType: [],
      keyWord: "",
      visible: true,
      confirmVisible: false,
      addCollectionVisible: false,
      title: this.$t("deviceManagement.configHistory.deletePrompt"),
      roleType: "favorites",
      delKey: null,
      isDelDiaLog: false,
      dataLoading: false,
    };
  },
  watch: {
    addCollectionVisible: function (n) {
      if (n) {
        this.activeCamera = "";
      }
    },
  },
  mounted() {},
  methods: {
    handleSearch() {
      if (this.keyword.length > 50) {
        this.$message.error(this.$t("deviceManage.cameraManage.msgInfo5"));
        return;
      }
      this.refreshCollectionData();
    },
    refreshCollectionData() {
      this.queryCollectionData(this.attributeType, this.keyword);
    },
    queryCollectionData(types, keyword, name) {
      this.dataLoading = true;
      if (name) {
        this.$fetch(api.queryFolderList).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
            return;
          }
          const _data = res.returnObj;
          this.mData = _data;
        });
      } else {
        this.attributeType = types || ["0", "1", "2"];
        this.keyWord = keyword || "";
        this.$fetch(api.queryFolderList).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
            return;
          }
          const _data = res.returnObj;
          this.mData = _data;
        });
      }
      setTimeout(() => {
        this.dataLoading = false;
      }, 300);
    },
    addCollection() {
      this.addCollectionVisible = true;
    },
    handleSave() {
      if (!this.collectionName) {
        return;
      }
      if (this.collectionName.length > 50) {
        this.$message.error(this.$t("video.message.disableFlodMore"));
        return;
      }
      const reg = new RegExp(/^[A-Za-z0-9\u4e00-\u9fa5]+$/);
      if (!reg.test(this.collectionName)) {
        this.$message.error(this.$t("video.message.disableFlodReg"));
        return;
      }
      let AddFolderVo = {};
      AddFolderVo.folderName = this.collectionName;
      AddFolderVo.superFolderCode = -1; // 上级文件夹编号
      // AddFolderVo.superFolderCode = this.currentVidecon ? this.currentVidecon.id : -1 // 上级文件夹编号
      this.$fetch(api.addFolder, AddFolderVo).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.queryCollectionData();
        this.handleCancel();
        this.collectionName = "";
      });
    },
    handleCancel() {
      this.collectionName = "";
      this.addCollectionVisible = false;
      // this.$emit('update:addCollectionVisible', false)
    },
    handleActiveExpand(val) {
      if (this.activeExpand === val && this.expand) {
        this.expand = false;
        this.activeCamera = val;
        return;
      }
      this.expand = true;
      this.activeExpand = val;
      this.activeCamera = val;
    },
    handleActiveCamera(val) {
      this.activeCamera = val.favoriteId + "_" + val.thirdCameraId;
    },
    handleEdit(item) {
      this.activeCamera = item.id;
      this.editCollectionName = item.name;
      this.isEdit = true;
    },
    handleCameraEdit(camera) {
      this.activeCamera = camera.favoriteId + "_" + camera.thirdCameraId;
      this.editCollectionName = camera.favCameraName;
      this.isEdit = true;
    },
    handleEditCancel() {
      this.isEdit = false;
    },
    handleSaveEdit(item) {
      if (!this.editCollectionName) {
        return;
      }
      if (this.editCollectionName.length > 50) {
        this.$message.error(this.$t("video.message.disableFlodMore"));
        return;
      }
      const reg = new RegExp(/^[A-Za-z0-9\u4e00-\u9fa5]+$/);
      if (!reg.test(this.editCollectionName)) {
        this.$message.error(this.$t("video.message.disableFlodReg"));
        return;
      }
      this.$fetch(api.updateFolder, {
        folderName: this.editCollectionName,
        folderCode: item.id,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.isEdit = false;
        item.name = this.editCollectionName;
        this.editCollectionName = "";
      });
    },
    handleCameraSaveEdit(item) {
      if (!this.editCollectionName) {
        return;
      }
      if (this.editCollectionName.length > 50) {
        this.$message.error(this.$t("video.message.disableFlodMore"));
        return;
      }
      const reg = new RegExp(/^[A-Za-z0-9\u4e00-\u9fa5]+$/);
      if (!reg.test(this.editCollectionName)) {
        this.$message.error(this.$t("video.message.disableFlodReg"));
        return;
      }
      this.$fetch(api.updateFolder, {
        folderName: this.editCollectionName,
        folderCode: item.id,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.isEdit = false;
        item.favCameraName = this.editCollectionName;
        this.editCollectionName = "";
      });
    },
    handleDel(val) {
      this.delKey = val;
      this.roleType = "favorites";
      this.openDialog();
    },
    openDialog() {
      // this.$emit('handleToggle')
      // if (!this.isDelDiaLog) {
      //   this.isDelDiaLog = true;
      //   this.$nextTick(() => {
      //     this.confirmVisible = true;
      //   });
      //   return
      // }
      // this.confirmVisible = true;
      this.$confirm(
        `您确定删除该${this.$t("video.label." + this.roleType)}吗?`,
        "确认",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.handleConfirm();
      });
    },
    handleDelCamera(val) {
      this.delKey = val;
      this.roleType = "camera";
      this.openDialog();
    },
    hasCollectionChecked(val) {
      return this.collectionChecked.some((item) => item === val)
        ? "checked"
        : "";
    },
    hasCameraChecked(val) {
      return this.checkedList.some((item) => item.id === val.id)
        ? "checked"
        : "";
    },
    handleChecked(val) {
      if (this.collectionChecked.some((item) => item === val.id)) {
        this.collectionChecked = this.collectionChecked.filter(
          (item) => item !== val.id
        );
        this.semiChecked = this.semiChecked.filter((item) => item !== val.id);
        if (val.children && val.children.length > 0) {
          this.checkedList = this.checkedList.filter(
            (item) => item && !this.validateChecked(val.children, item)
          );
        }
        this.$emit("change", this.checkedList);
        return;
      }
      this.collectionChecked.push(val.id);
      if (val.children && val.children.length > 0) {
        this.checkedList = [...this.checkedList, ...val.children];
      }
      // console.log(this.checkedList.length);
      this.$emit("change", this.checkedList);
    },
    handleCameraChecked(val, children) {
      if (this.checkedList.some((item) => item === val)) {
        this.checkedList = this.checkedList.filter((item) => item !== val);
        const _number = this.checkedType(children);
        console.log(_number);
        if (_number === 0) {
          this.semiChecked = this.semiChecked.filter((item) => item !== val.id);
        }
        if (_number < children.length) {
          this.collectionChecked = this.collectionChecked.filter(
            (item) => item !== val.id
          );
        }
        this.$emit("change", this.checkedList);
        return;
      }
      this.checkedList.push(val);
      const _number = this.checkedType(children);
      if (_number === children.length) {
        this.collectionChecked.push(val.id);
      } else {
        if (!this.semiChecked.some((item) => item === val.id)) {
          this.semiChecked.push(val.id);
        }
      }
      this.$emit("change", this.checkedList);
    },
    deviceChoose(nodeData) {
      if (nodeData.status != 1) {
        this.$message.warning(this.$t("business.message.offline"));
        return;
      }
      this.$emit("deviceChoose", nodeData);
    },
    validateChecked(favcameras, val) {
      return favcameras.some((item) => item.id === val.id);
    },
    hasEditClass(favoriteId) {
      return this.isEdit && this.activeCamera === favoriteId ? "edit" : "";
    },
    hasActiveClass(favoriteId) {
      return this.activeCamera === favoriteId ? "active" : "";
    },
    hasExpandClass(favoriteId) {
      return this.activeExpand === favoriteId && this.expand ? "expand" : "";
    },
    hasSemiClass(favoriteId) {
      return this.semiChecked.some((item) => item === favoriteId) ? "semi" : "";
    },
    checkedType(children) {
      let _arr = this.checkedList.filter(
        (item) => item && this.validateChecked(children, item)
      );
      return _arr.length;
    },
    hasAttributeTypeClass(type) {
      switch (type) {
        case "0":
          return "icon-putong";
        case "1":
          return "icon-renlianshibie";
        case "2":
          return "icon-cheliangshibie";
      }
    },
    hasCameraTypeClass(type) {
      switch (type) {
        case "0":
          return "icon-gun-machine";
        case "1":
          return "icon-gun-machine";
        case "2":
          return "icon-ball-machine ball";
        default:
          return "icon-gun-machine";
      }
    },
    handleConfirm() {
      if (this.roleType === "favorites") {
        this.$fetch(api.deleteFolderOrMonitorPoint, [
          {
            id: this.delKey.id,
            nodeType: "file",
            parentId: "-1",
          },
        ]).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.confirmVisible = false;
          this.queryCollectionData();
        });
        return;
      }
      this.$fetch(api.deleteFolderOrMonitorPoint, [
        {
          id: this.delKey.id,
          nodeType: "device",
          parentId: this.delKey.parentId,
        },
      ]).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.confirmVisible = false;
        this.queryCollectionData();
      });
    },
    handlePlayFa(favoriteId, val) {
      if (val.length === 0) {
        this.$message.error(
          this.$t("deviceManagement.configHistory.inExistence")
        );
        return;
      }
      this.$fetch("/vms/favorite/recordCameraFavorites", {
        favoriteId: favoriteId,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        }
      });
      const _cameras = val
        .filter((item, index) => item && index < 12)
        .map((item) => {
          return {
            cameraCode: item.thirdCameraId,
            cameraName: item.favCameraName,
          };
        });
      console.info("播放收藏夹", _cameras);
      this.$emit("handlePlayVideo", _cameras);
    },
    hanleDbclickPlay(camera) {
      this.$emit("handlePlayVideo", [
        { cameraCode: camera.thirdCameraId, cameraName: camera.favCameraName },
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/ioc/pages/common.scss";
.position-no-result {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: $soc-font-color;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      font-size: 20px;
      line-height: 24px;
      margin-right: 8px;
    }
  }
}
.videoConfigList .add_collection_d {
  margin-top: -7px;
}
.add_collection_d {
  margin-top: 16px;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 12px;
  border-left: $soc-primary-color solid 3px;
  background: linear-gradient(
    to right,
    rgba($soc-primary-color, 0.7),
    transparent
  ) !important;
  background: -ms-linear-gradient(
    left,
    rgba($soc-primary-color, 0.7),
    transparent
  ) !important;
  background: -webkit-linear-gradient(
    left,
    rgba($soc-primary-color, 0.7),
    transparent
  ) !important;

  .checked_box {
    width: 15px;
    height: 15px;
    border: #586583 solid 1px;
    margin-right: 5px;
  }

  .file_class {
    color: #fece63;
    font-size: 22px;
    line-height: 22px;
    margin-left: 5px;
    margin-right: 8px;
  }
}

.collection_ul {
  width: 100%;
  flex: 1;
  list-style: none;
  display: flex;
  flex-direction: column;

  &.sub {
    height: 0;
    opacity: 0;
    overflow: hidden;
    transition: height 0.3s, opacity 0.3s;
    -webkit-transition: height 0.3s, opacity 0.3s;

    &.expand {
      height: auto;
      opacity: 1;
    }

    li {
      width: 320px;

      .collection_li_container_sub {
        height: 36px;
        width: 320px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 12px 0 55px;

        &.edit {
          .collection_content {
            .collection_options {
              width: 0px !important;
            }

            .label {
              display: none;
            }

            .icon_type {
              display: none;
            }
          }
        }

        .collection_content {
          .device_icon {
            padding: 0 5px;
            font-size: 14px;
            line-height: 14px;

            &.ball {
              font-size: 12px;
              line-height: 12px;
            }
          }

          .label {
            font-size: 14px;
            flex: 1;
            cursor: pointer;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100px;
          }

          .icon_type {
            width: 24px;
            color: $soc-font-color;

            i {
              font-size: 24px;
              line-height: 24px;
            }
          }
        }

        &:hover {
          background-color: rgba(#465275, 0.4);

          .collection_content {
            .collection_options {
              width: 50px;
              cursor: pointer;
            }

            .icon_type {
              display: none;
            }
          }
        }

        &.active {
          cursor: pointer;
          border-left: $soc-primary-color solid 3px;
          background: linear-gradient(
            to right,
            rgba($soc-primary-color, 0.7),
            transparent
          ) !important;
          background: -ms-linear-gradient(
            left,
            rgba($soc-primary-color, 0.7),
            transparent
          ) !important;
          background: -webkit-linear-gradient(
            left,
            rgba($soc-primary-color, 0.7),
            transparent
          ) !important;
          padding: 0 12px 0 52px;

          .collection_content {
            .collection_options {
              width: 50px;
            }

            .icon_type {
              display: none;
            }
          }
        }
      }
    }
  }

  li {
    /*&:hover {*/
    /*.sub {*/
    /*height: auto;*/
    /*opacity: 1;*/
    /*}*/

    /*}*/
    width: 300px;

    .collection_li_container {
      height: 36px;
      width: 300px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 12px 0 16px;

      &:hover {
        background-color: rgba(#465275, 0.4);

        .collection_content {
          .collection_options {
            width: 80px;
          }
        }
      }

      &.active {
        cursor: pointer;
        border-left: $soc-primary-color solid 3px;
        background: linear-gradient(
          to right,
          rgba($soc-primary-color, 0.7),
          transparent
        ) !important;
        background: -ms-linear-gradient(
          left,
          rgba($soc-primary-color, 0.7),
          transparent
        ) !important;
        background: -webkit-linear-gradient(
          left,
          rgba($soc-primary-color, 0.7),
          transparent
        ) !important;
        padding: 0 12px 0 13px;

        .collection_content {
          .collection_options {
            width: 80px;
          }

          .label {
            width: 100px;
          }
        }
      }

      &.edit {
        .collection_content {
          .collection_options {
            width: 0;
          }
        }
      }
    }

    .checked_box {
      width: 15px;
      height: 15px;
      border: #586583 solid 1px;
      margin-right: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        opacity: 0;
        transition: opacity 0.2s;
        -webkit-transition: opacity 0.2s;
        font-size: 11px;
      }

      &.checked {
        border-color: $soc-primary-color;
        background-color: $soc-primary-color;
        border-width: 1px !important;

        i {
          opacity: 1;
          color: #fff;
        }
      }

      &.semi {
        border-color: $soc-primary-color;
        border-width: 4px;
      }
    }

    .collection_content {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      overflow: hidden;
      height: 100%;

      .file_class {
        color: #fece63;
        font-size: 22px;
        line-height: 22px;
        margin-left: 5px;
        margin-right: 8px;
      }

      &:hover {
        .collection_options {
          width: 80px;
        }

        .label {
          width: 100px;
        }
      }

      .label {
        font-size: 14px;
        flex: 1;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .collection_options {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 0;
        overflow: hidden;
        transition: width 0.3s;
        -webkit-transition: width 0.3s;
        cursor: pointer;
        i {
          font-size: 14px;
          line-height: 14px;
          color: $soc-font-color;
          margin-right: 25px;
          &:hover {
            color: #fff;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>